import { totalProgression, type LocatorJson } from "@msb/reader-bridge";
import { defineMessages, translator, type Locale } from "./i18n/index.ts";

/**
 * Progression de lecture entre 0 et 1 : la page lue sur le nombre de pages, si on le connaît
 * (la dernière page vaut 1, « Terminé »), sinon la progression globale donnée par Readium.
 */
export function readingProgress(locator: LocatorJson, positionCount?: number): number | undefined {
  const position = locator.locations?.position;
  if (typeof position === "number" && positionCount && positionCount > 0) return Math.min(1, Math.max(0, position / positionCount));
  return totalProgression(locator);
}

const messages = defineMessages(
  { excerpt: "EXTRAIT", new: "NOUVEAU", finished: "TERMINÉ", percent: "{value} %" },
  { excerpt: "EXCERPT", new: "NEW", finished: "FINISHED", percent: "{value}%" },
);

/** Texte de la barre de statut sous la couverture, comme dans l'app (BookStatusBar). */
export function progressLabel(progress: number | undefined, isExtract: boolean, locale: Locale = "fr"): string {
  const t = translator(messages, locale);
  if (isExtract) return t("excerpt");
  if (progress === undefined) return t("new");
  if (progress >= 1) return t("finished");
  // 99,6 % ne s'affiche pas « 100 % » tant que la dernière page n'est pas atteinte.
  return t("percent", { value: Math.min(99, Math.round(progress * 100)) });
}
